













import { computed, defineComponent } from "@vue/composition-api";
import Heading from "@/components/Atoms/Typography/Heading/index.vue";
import RelatedLinksFooter from "@/components/Organisms/RelatedLinksFooter/index.vue";
import { ExternalDataProcessors } from "@/assets/docs/ExternalDataProcessors";
import "@/components/icons";

const marked = require("marked/lib/marked"); // NOTE: "marked/lib/marked"からないとIEで機能しない。
export default defineComponent({
  name: "ExternalDataProcessors",
  components: {
    Heading,
    RelatedLinksFooter
  },
  setup() {
    const compiledMarkdown = computed(() => {
      return marked(ExternalDataProcessors);
    });
    return { compiledMarkdown };
  }
});
